'use client';
import { useMemo } from 'react';

import { SemanticsExtended, ThemeProvider } from '@veneer/theme';

import { defaultTheme, themes } from './ThemeProviderWrapper.themes';

export default function ThemeProviderWrapper({
  children,
  shape = 'sharp',
  theme,
}: Readonly<{
  children: React.ReactNode;
  shape?: 'sharp' | 'round';
  theme?: SemanticsExtended | string;
}>) {
  const getTheme = useMemo(() => {
    if (!theme) return defaultTheme;

    if (typeof theme === 'string') {
      theme = themes[theme];
    }

    return { ...defaultTheme, ...theme };
  }, [theme]);

  return (
    <ThemeProvider shape={shape} mode="light" customSemantics={getTheme}>
      {children}
    </ThemeProvider>
  );
}
